import { useInfiniteQuery } from 'react-query'
import { getRequestMessageInPage2 } from 'services/messages'

export const MESSAGES_QUERY_KEY = ['get-request-message-in-page-2']

export default function useGetRequestMessage() {
    const query = useInfiniteQuery(
        MESSAGES_QUERY_KEY,
        ({ pageParam = 'None' }) => getRequestMessageInPage2(pageParam),
        {
            getNextPageParam: (lastPage) => lastPage?.last_date || undefined,
            // Every page of this endpoint walks the member's whole inbox
            // (`RequestMessagesInPage` iterates the full queryset), and an
            // infinite query refetches *every* loaded page. The global
            // refetch-on-focus turned each tab switch back to the app into
            // N full scans; a remount after 30s is fresh enough for an inbox.
            refetchOnWindowFocus: false,
            staleTime: 30_000,
        }
    )
    return { ...query, requestMessage: query.data }
}
